import * as m from 'motion/react-m'
import { Motion } from '@/lib/motion/lazy-motion'

import AuthPortal, { type AuthConfigProps } from './AuthPortal'
import Overlay from '@/components/search/common/Overlay'

type AuthModalProps = {
  close: () => void
  redirectUrl?: string
  config?: AuthConfigProps
}

export default function AuthModal({ close, redirectUrl, config }: AuthModalProps) {
  return (
    <>
      <div className="fixed bottom-0 left-0 z-[100] w-full sm:bottom-auto sm:left-1/2 sm:top-1/2 sm:max-w-[520px] sm:-translate-x-1/2 sm:-translate-y-1/2">
        <Motion>
          <m.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="flex justify-center rounded-t-2xl bg-white px-5 py-10 xs:px-10 sm:rounded-b-2xl"
          >
            <AuthPortal redirectUrl={redirectUrl} config={config} />
          </m.div>
        </Motion>
      </div>

      <Overlay close={close} background={true} z={90} />
    </>
  )
}
